// removed by extract-text-webpack-plugin
module.exports = {"main_right_content":"components-tjcx-xsjfcxtj-index-main_right_content-9LzSk","table":"components-tjcx-xsjfcxtj-index-table-qoO2z"};


//////////////////
// WEBPACK FOOTER
// ./components/tjcx/xsjfcxtj/index.css
// module id = 565
// module chunks = 0